import React, { useEffect, useState } from "react";
import httpos from "../../helpers/httpos";

export default function Testing() {
  useEffect(() => {
    function get_data() {
      httpos
        .post("/search-data", { search_query: "30022", search_type: "zipcode" })
        .then((response) => {
          console.log(response?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    get_data();
  }, []);

  return (
    <section className="property_list_grid property_list_sec favorite_property_grid">
      <div className="contain-fluid">
        <h4 className="light_heading f_s_24">Favorite Properties</h4>
      </div>
    </section>
  );
}
